import { useEntity } from '@backstage/plugin-catalog-react';
import { InfoCard, InfoCardVariants } from '@backstage/core-components';
import { useEntityUrls, useEntityRefresh } from '../hooks';
import { ActionButtonsList } from '../ActionButton';
import { EntityFields, EntitySubheader } from '../EntityFields';

// https://backstage.io/docs/reference/plugin-catalog.entityaboutcard/
// Backstage docs for EntityAboutCard recommend replacing the default with a custom card
// This is a custom card that adds additional information to the default card

export const HerokuEntityAboutCard = ({
  variant,
}: {
  variant?: InfoCardVariants;
}) => {
  const { entity } = useEntity();
  const urls = useEntityUrls(entity);
  const refreshData = useEntityRefresh(entity, urls.entityLocation);

  return (
    <InfoCard
      title={`About ${entity.metadata.name || 'Unknown'}`}
      subheader={<EntitySubheader entity={entity} />}
      variant={variant}
      action={<ActionButtonsList urls={urls} refreshData={refreshData} />}
    >
      <EntityFields entity={entity} />
    </InfoCard>
  );
};
